import React from "react";

import { FaStar } from "react-icons/fa";
import "./star.css";

export const Star = ({ className }) => {
    return <FaStar className={`star ${className}`} />;
};
